var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11H17V12.5H7V11ZM7 8.5H17V10H7V8.5ZM7 6H17V7.5H7V6ZM19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C4.86 3 4.73 3.01 4.6 3.04C4.21 3.12 3.86 3.32 3.59 3.59C3.41 3.77 3.26 3.99 3.16 4.23C3.06 4.46 3 4.72 3 5V19C3 19.27 3.06 19.54 3.16 19.78C3.26 20.02 3.41 20.23 3.59 20.42C3.86 20.69 4.21 20.89 4.6 20.97C4.73 20.99 4.86 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 2.75C12.41 2.75 12.75 3.09 12.75 3.5C12.75 3.91 12.41 4.25 12 4.25C11.59 4.25 11.25 3.91 11.25 3.5C11.25 3.09 11.59 2.75 12 2.75ZM19 19H5V5H19V19Z",
    fill: "#78CF46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7211 15V16C11.7211 16.55 11.485 17 11.1965 17H7.52457C7.23606 17 7 16.55 7 16V15C7 14.45 7.23606 14 7.52457 14H11.1965C11.485 14 11.7211 14.45 11.7211 15Z",
    fill: "#78CF46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15V16C17 16.55 16.7639 17 16.4754 17H12.8035C12.515 17 12.2789 16.55 12.2789 16V15C12.2789 14.45 12.515 14 12.8035 14H16.4754C16.7639 14 17 14.45 17 15Z",
    fill: "#78CF46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateButtonIcon);
export default __webpack_public_path__ + "static/media/template_button_icon.bb9b599f.svg";
export { ForwardRef as ReactComponent };